import React from "react";
import PropTypes from "prop-types";
import {SVPModalDeleteButtonStyle} from "./SVPModalDeleteButton.styles";

export const SVPModalDeleteButton = ({
    form,
    onClick,
    buttonText = "Delete",
    isDisabled = false,
}) => {
    return <>
        <SVPModalDeleteButtonStyle disabled={isDisabled} onClick={onClick} form={form} className="cta-btn-secondary">
            {buttonText}
        </SVPModalDeleteButtonStyle>
    </>;
};

SVPModalDeleteButton.propTypes = {
    form: PropTypes.string,
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    buttonText: PropTypes.string,
};
